<template>
    <ui-dropdown :placement="placement" menu-class="w-[24em]" :trigger-class="triggerClass" :arrow="false"
                 @closed="(e) => $emit('closed',e)" @opened="(e) => $emit('opened',e)">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>
        <template #menu="{ close }">
            <div class="p-5 pt-3">
                <div>
                    <div class="text-xs font-medium text-gray-400 mb-4">Updating Multiple Items</div>
                    <p class="mt-4 text-sm">
                        Updating the material name, supplier or cost for this {{ type }} will update
                        <strong>ALL</strong>
                        matching materials across this {{ type }}.
                    </p>
                    <p class="mt-4 text-sm" v-if="item.name !== original.name">
                        The new material name for this item will be: <strong>"{{ item.name }}"</strong>
                    </p>
                    <p class="mt-4 text-sm" v-if="item.supplier !== original.supplier">
                        The new supplier name for this item will be: <strong>"{{ item.supplier }}"</strong>
                    </p>
                    <p class="mt-4 text-sm" v-if="resolveNumericText(item.cost) !== resolveNumericText(original.cost)">
                        The new cost for this material will be: <strong>{{ newCost() }}</strong>
                    </p>

                    <p class="mt-4 text-sm">Are you sure you want to continue?</p>
                    <div class="mt-6 flex justify-end space-x-6">
                        <ui-button-new @click.stop.prevent="close">Cancel</ui-button-new>
                        <ui-button-new warning @click.stop.prevent="update(close)">
                            Yes, update materials
                        </ui-button-new>
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import {resolveNumericText, toCurrency} from "../../../../utils";

export default {
    props: {
        original: Object,
        item: Object,
        triggerClass: String,
        alignRight: Boolean,
        type: String,
    },
    data() {
        return {
            resolveNumericText,
        }
    },
    computed: {
        placement() {
            return this.alignRight ? 'bottom-end' : 'bottom-start'
        },
    },
    methods: {
        scope(dropdownScope) {
            let that = this
            return {
                ...dropdownScope,
            }
        },
        newCost() {
            return toCurrency(resolveNumericText(this.item.cost))
        },
        update(close = () => {}) {
            this.item.cost = parseFloat(('' + this.newCost()).replace(/[^0-9.]/g, ''));
            this.$emit('updated')
            close()
        },
    },
    mounted() {
    }
}
</script>
